<template>
  <b-card-group v-if="menuList.length > 0" deck>
    <b-card no-body class="products-tab">
      <h5 slot="header" class="sidebar-header">
        <span class="computed-title">{{ menuTitle }}</span><span class="triangle"></span>
      </h5>
      <b-list-group flush>
        <b-list-group-item
          v-for="(menu, index) in menuList"
          :key="index"
          :to="urlPrefixer(menu.url)"
          :target="menu.target"
          :class="menu.url === currentMenu.url ? 'current-menu' : ''">
          <i class="fas fa-angle-right triangle-icon"></i>
          {{ menu.menuTitle !== false ? menu.menuTitle : ls_AllMenus }}
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </b-card-group>
</template>

<script>
export default {
  props: ["menuTitle", "menuList", "currentMenu"],

  computed: {
    ls_AllMenus() {
      return this.$store.state.languagePack.ls_AllMenus;
    }
  },

  methods: {
    urlPrefixer(url) {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln + url
        : url;
    }
  }
};
</script>

<style lang="scss" scoped>
.products-tab {
  border: 0;

  .card-header {
    border: 0;
    padding: 0;

    .sidebar-header {
      position: relative;
      margin-bottom: 0;
      border-top: 2px solid #008496;
      background-color: #00849611;

      .computed-title {
        display: inline-block;
        min-height: 1.875rem;
        padding: 8px 16px;
        color: #212525;
        font-family: 'Open Sans', sans-serif;
        font-size: 1.125rem;
        font-weight: 600;
      }

      // .triangle {
      //   position: absolute;
      //   top: 0;
      //   display: inline-block;
      //   width: 0;
      //   height: 0;
      //   border-width: 1rem 0.5rem;
      //   border-style: solid;
      //   border-color: #f6f6f6 #f6f6f6 #008496 #008496;
      // }
    }
  }

  .list-group {
    padding-top: 4px;
    padding-bottom: 4px;

    .list-group-item {
      position: relative;
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      color: #777777;
      font-weight: 600;
      padding: 7px 16px 7px 42px;
      background-color: #ffffff;
      border: 0;
      transition: text-decoration 0.2s ease-in-out;

      &:hover {
        color: #1974b5;
        text-decoration: underline #1974b5;
      }
      

      .triangle-icon {
        position: absolute;
        left: 26px;
        color: #1974b5;
        line-height: 1.5;
      }
    }

    .current-menu {
      color: #1974b5;
    }
  }
}

/* RTL */

.rtl-layout .products-tab {
  .sidebar-header {
    direction: rtl;
    text-align: right;
  }
  .list-group-item {
    direction: rtl;
    text-align: right;
    padding: 7px 42px 7px 16px;

    &:hover {
      color: #1974b5;
      text-decoration: underline #1974b5;
    }
    

    .triangle-icon {
      position: absolute;
      right: 26px;
      transform: rotate(180deg);
      left: calc(100% - 26px);
      color: #1974b5;
      line-height: 1.5;
    }
  }
}
</style>
